module.exports = __webpack_public_path__ + "static/media/23import-52.7ff42069.xlsx";